<!-- filepath: /Users/desarrollo/Documents/Proyectos/friax/src/views/Home.vue -->
<template>
  <div class="content-custom">
    <carrouselHeader />
    <div class="d-flex justify-content-center bg-gray">
      <div data-animation="FadeInUp" class="w-auto  bg-gray d-flex align-items-center my100 ">
        <div class="divSembrando  mx-auto row">
          <p class=" titulo">Sembrando tu futuro</p>
          <p class=" message textSembrando">
            <span>En FRIAX creamos oportunidades accesibles para las familias, ofreciendo </span>
            <b>terrenos a precios justos</b>
            <span> y </span>
            <b>opciones de financiamiento</b>
            <span> que facilitan la adquisición de propiedades. La confianza es el pilar de nuestras relaciones,
              asegurando transparencia en cada paso del proceso. Además, nos comprometemos con el </span>
            <b>desarrollo sostenible</b>
            <span>, diseñando fraccionamientos que beneficien tanto a nuestros clientes como a la comunidad a largo
              plazo.</span>
          </p>
          <button type="button" @click="() => $router.push('/contacto')"
            class="btn btn-primary btn-rounded  text-uppercase mx-auto">Contáctanos</button>

        </div>
        <div class="divImgVectorSembrando d-none d-md-block">
          <img src="assets/images/home/Friax_Vector.svg" class="imgVectorSembrando">
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="divCarrouselHome1 col-10 row">
        <div data-animation="FadeInLeft" class="col-lg-6 col-md-12 col-12 h500">
          <div id="carouselExampleSlidesOnly" class="carousel carrouselHome1 slide" data-bs-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img src="assets/images/home/Friax_Slider1.png" class="img-fluid " alt="...">
              </div>
              <div class="carousel-item">
                <img src="assets/images/home/Friax_Slider2.png" class="img-fluid " alt="...">
              </div>
              <div class="carousel-item">
                <img src="assets/images/home/Friax_Slider3.png" class="img-fluid " alt="...">
              </div>
            </div>
          </div>
        </div>
        <div data-animation="DerAIzq" class="carrouselHome1Text mr-auto">
          <div class="ml20Porcent bg-white carrouselHome1Div">
            <p class="carrouselHome1Titulo1">Transformamos ideas en realidades,
              creando espacios donde nacen los mejores momentos.</p>
            <p class="carrouselHome1Titulo2">Nuestro modelo de negocio se basa en crear relaciones duraderas
              con nuestros clientes.</p>
            <div class="carrouselHome1Titulo3">
              <div class="d-flex">
                <img src="assets/images/home/Checkmark.svg" class="d-block img-check" width="24px" height="24px"
                  alt="...">
                <p class="ofrecemos-un-proceso">Ofrecemos un proceso transparente, con precios competitivos.</p>
              </div>
              <div class="d-flex">
                <img src="assets/images/home/Checkmark.svg" class="d-block img-check" width="24px" height="24px"
                  alt="...">
                <p class="ofrecemos-un-proceso">Facilitamos la adquisición de propiedades sin complicaciones.</p>
              </div>
              <div class="d-flex">
                <img src="assets/images/home/Checkmark.svg" class="d-block img-check" width="24px" height="24px"
                  alt="...">
                <p class="ofrecemos-un-proceso">Ubicación estratégica y calidad de infraestructura.</p>
              </div>
            </div>
            <div class="carrouselHome1Btn">
              <button type="button" @click="() => $router.push('/contacto')"
                class="btn btn-primary  btn-rounded  text-uppercase mt30">Contáctanos</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-animation="FadeIn" class="d-flex justify-content-center  bg-primary text-white">
      <div class="mt75 mb110 col-10">
        <p class=" text-center font48 fw-bold mb30">¿Por qué elegirnos?</p>
        <div class="divContenedorBeneficio">
          <div v-for="(beneficio, index) in beneficios" class="divBeneficio" :key="'Key' + index">
            <div class="">
              <img :src="getImageUrl(beneficio.imgSrc)" class="d-block mx-auto" width="100px" height="100px" alt="...">
              <p class="w-full font20 my5 fw-bold text-uppercase">{{ beneficio.title }}</p>
              <p class="font16">{{ beneficio.description }}</p>
            </div>
            <div class="contenedorLineDiv ">
              <div class="line-div" :class="index == 3 ? 'line-divUnset' : ''"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-animation="FadeIn" class="d-flex justify-content-center">
      <div class="mt150 mb100 col-10 text-center">
        <!-- <img class="" alt="" src="assets/images/logos/LogoTerranovaAzul.png" width="200px" height="110px" /> -->

        <div class="font36 fw-bold text-secondary">Conoce nuestro nuevo proyecto</div>
        <b class="fw-bold font64 text-primary">Tu futuro empieza aquí</b>
        <div class="row d-flex justify-content-center align-items-start">
          <div class="col-12 col-lg-3 col-xl-3 mt75 ">
            <span>Ofrecemos terrenos y casas de calidad en un </span>
            <b class="fw-bold text-primary3">fraccionamiento privado</b>
            <span>, con todos los servicios y facilidades, en una </span>
            <b class="fw-bold text-primary3">ubicación estratégica</b>
            <span> para la estabilidad y seguridad de tu familia.</span>
          </div>
          <div class="col-12 col-lg-6 col-xl-6 mt-auto d-flex">
            <img alt="" src="assets/images/home/RenderTerranova.png" class="img-fluid mx-auto" />
          </div>
          <div class="col-12 col-lg-3 col-xl-3 mt75">
            <span>Lotes residenciales en el </span>
            <b class="fw-bold text-primary3">primer fraccionamiento</b>
            <span> de Chihuahua que te permite </span>
            <span class="fw-bold text-primary3">
              <b>utilizar tu crédito INFONAVIT</b>
              <span class="span">.</span>
            </span>
          </div>
        </div>
        <div class="col-12">
          <button type="button" @click="() => $router.push('/terranova')"
            class="btn btn-primary btn-rounded text-uppercase mx-auto mt30">ver proyecto</button>
        </div>
      </div>
    </div>
    <div data-animation="FadeIn" class="divContenedorConfiable bg-image text-white text-center">
      <div class="divConfiable mx-auto ">
        <div class=" col-12 font24 text-uppercase titulo2">Más que una constructora...</div>
        <b class=" col-12 text-uppercase font48 lh120Porcent titulo ">¡somos un socio confiable para adquirir un
          hogar!</b>
        <div class=" col-12 font20 lh150Porcent fontAcuminPro message mt35">
          En FRIAX te brindamos confianza y apoyo en tu camino hacia encontrar un nuevo <br> hogar.
          Como tu socio en este proceso, ofrecemos terrenos y casas accesibles, además de un acompañamiento
          transparente, transformando tus metas en realidad.
        </div>
        <div class="col-12">
          <button type="button" @click="() => $router.push('/contacto')"
            class="btn btn-primary btn-rounded text-uppercase mx-auto mt30">contáctanos</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Beneficios from '../components/beneficios.vue';
import carrouselHeader from '../components/home/carrouselHeader.vue';

import { inject } from 'vue';
export default {
  name: 'Home',
  components: {
    carrouselHeader
  },
  setup() {
    const screenWidth = inject('screenWidth');
    const getImageUrl = inject('getImageUrl');

    return {
      screenWidth,
      getImageUrl
    };
  },
  data() {
    return {
      beneficios: [
        {
          imgSrc: "assets/images/home/1.svg",
          imgAlt: "Ubicación Estratégica",
          title: "Ubicación Estratégica",
          description: "Seleccionamos ubicaciones privilegiadas que mejoran tu calidad de vida, y que también potencian el valor de tu inversión."
        },
        {
          imgSrc: "assets/images/home/2.svg",
          imgAlt: "Gran plusvalía",
          title: "Gran plusvalía",
          description: "Nuestros proyectos están diseñados para ofrecerte plusvalía atractiva, asegurando que tu compra se valore con el tiempo."
        },
        {
          imgSrc: "assets/images/home/3.svg",
          imgAlt: "Seguridad total",
          title: "Seguridad total",
          description: "Cumplimos con altos estándares de calidad y normativas para brindarte la seguridad que mereces en cada adquisición."
        },
        {
          imgSrc: "assets/images/home/4.svg",
          imgAlt: "La mejor oferta",
          title: "La mejor oferta",
          description: "Creamos proyectos que no solo perduran en el tiempo, sino que también respetan y enriquecen el entorno donde se ubican."
        }
      ],
    };
  }
};
</script>






<style scoped>
@import '~animate.css/animate.min.css';

.bg-image {

  background-image: url("../../public/assets/images/home/Friax_BannerPreFooter1.png");
  /* Cambia esta ruta a la de tu imagen */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>